import { Action } from "@reduxjs/toolkit";
import { Rootstate } from "../../store";


const defaultState = {
    editGrid: false,
    xOffset: 0,
    yOffset: 0,
    xTiles: 10,
    yTiles: 10,
};

interface GridReducerAction extends Action {
  value: number
}

const gridReducer = (state = defaultState, action: GridReducerAction): typeof defaultState => {
    switch (action.type) {
    case 'GRID/TOGGLE_EDIT':
        return {
            ...state,
            editGrid: !state.editGrid,
        };
    case 'GRID/SET_X_OFFSET':
        return {
            ...state,
            xOffset: action.value,
        };
    case 'GRID/SET_Y_OFFSET':
        return {
            ...state,
            yOffset: action.value,
        };
    case 'GRID/SET_Y_TILES':
        return {
            ...state,
            yTiles: action.value,
        };
    case 'GRID/SET_X_TILES':
        return {
            ...state,
            xTiles: action.value,
        };
    default:
        return state;
    }
};

export const gridSelector = (state: Rootstate) => state.grid;

export default gridReducer;

